import { EventEmitter } from 'events'

class Timer extends EventEmitter {
  timer = 0
  tick = 0
  handle: any

  constructor(handle: () => void, time: number) {
    super()
    this.handle = handle
    this.tick = time
  }

  start() {
    this.stop()
    this.timer = window.setInterval(this.handle, this.tick)
  }

  stop() {
    window.clearInterval(this.timer)
  }
}

export default Timer
